export const getErrorPath = (uuid: string | undefined, status = 404) => {
  if (status >= 500) {
    return uuid ? `/${uuid}/virhe/muu` : '/virhe'
  }

  return uuid ? `/${uuid}/virhe` : '/virhe'
}
